import React, { useEffect, useState } from 'react';
import { Alert, Button, Form, Modal } from 'react-bootstrap';

/**
 * "Change Provider" dialog for the masking inventory page (opened from the page-header Actions
 * menu): pick the masking engine that runs this inventory. Controlled by the host — it only
 * collects the new serviceId and hands it back via onSubmit; the host re-derives every field's
 * recommended algorithm for that provider (staged until Save / Mask).
 */
export default function ChangeProviderDialog({ show, providers, selectedProvider, onSubmit, onCancel }) {
  const [choice, setChoice] = useState(selectedProvider || '');

  useEffect(() => {
    if (show) setChoice(selectedProvider || '');
  }, [show, selectedProvider]);

  const list = Array.isArray(providers) ? providers : [];
  const changed = choice !== '' && choice !== (selectedProvider || '');
  const submit = (e) => {
    if (e) e.preventDefault();
    if (changed) onSubmit(choice);
  };

  return (
    <Modal show={show} onHide={onCancel} centered>
      <Form onSubmit={submit}>
        <Modal.Header closeButton>
          <Modal.Title as='h6'>Change masking provider</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Group>
            <Form.Label>Masking provider</Form.Label>
            <Form.Control
              as='select'
              autoFocus
              value={choice}
              onChange={(e) => setChoice(e.target.value)}
              data-testid='change-provider-select'
            >
              {list.map((p) => (
                <option key={p.serviceId} value={p.serviceId}>
                  {p.vendorDisplayName || p.name}
                  {p.isDefault ? ' (default)' : ''}
                </option>
              ))}
            </Form.Control>
          </Form.Group>
          <Alert variant='warning' className='mb-0 sg-small'>
            Switching provider resets every field in this inventory to the new provider's recommended
            algorithm. Nothing is saved until you click Save or Mask.
          </Alert>
        </Modal.Body>
        <Modal.Footer>
          <Button variant='outline-secondary' onClick={onCancel}>
            Cancel
          </Button>
          <Button variant='primary' type='submit' disabled={!changed} data-testid='change-provider-submit'>
            Change provider
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
}
